import React, { useState, useEffect } from 'react';
import './AddleadSteps.css';
import { getBasicDetails } from '../../../common/constants/api';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import moment from 'moment';
// import KYCContainer from '../KYCContainer/KYC';
import { setUserName } from '../../../common/utils/cookie-utils';
// import Stepper from '../../../components/Stepper/Stepper';
import Steps from './Steps';
import FormikWizard from 'formik-wizard';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import Header from '../../../common/components/Header/Header';
import { getCustomerDetails } from '../../../common/constants/api';
let isFirstLoad = true;
const BASE_YEAR = 1950;
export const currentYear = parseInt(moment().format('YYYY'));
export const currentMonth = moment().format('MMMM');

function FormWrapper({
  children,
  currentStep = 'selfie',
  isLastStep,
  status,
  goToPreviousStep,
  canGoBack,
  steps,
  step,
  wizard,
  actionLabel
}) {
  return (
    <div className="bg-grey-950 relative min-h-screen overflow-auto font-roboto text-sm font-normal m-0 p-0">
      <div className=" min-h-screen flex pt-17 md:pt-0">
        <Sidebar />
        <div className="flex-1  w-full widhtMd max-screen">
          <Header />
          <div className="flex-1 pb-8 flex-row w-full relative">
            <div className="overflow-x-auto">
              {/* <Stepper activeStep={wizard.steps.indexOf(wizard.step) + 1} /> */}
            </div>
            {/* step is OTP isChangeNoNeed =  */}
            {children}
            {wizard.step.id === 'bankDetailsContainer' ? (
              <div className="appearance-none md:ml-auto md:mr-80 w-32 md:w-64"></div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

const AddleadSteps = () => {
  const [edit, setEdit] = useState(false);

  const [updatedSteps, updateSteps] = useState(Steps);
  React.useEffect(() => {
    const getcustomer = async () => {
      try {
        const url = new URL(window.location.href);
        const leadId = url.searchParams.get('leadId');
        console.log(leadId);

        if (leadId) {
          const customerdetails = await getCustomerDetails(leadId);
          console.log('getcustomer -> customerdetails', customerdetails);

          setEdit(true);
          const newSteps = updatedSteps;
          newSteps[0] = {
            ...newSteps[0],
            initialValues: {
              Name: customerdetails.name.firstName || '',
              middleName: customerdetails.name.middleName || '',
              lastName: customerdetails.name.lastName || '',
              email: customerdetails.email || '',
              mobile: customerdetails.phone || '',
              pincode: customerdetails.pincode || '',
              EnquiryStatus:
                customerdetails.status
                  .toUpperCase()
                  .split(' ')
                  .join('_') || '',
              ProductId: customerdetails.ProductId || '',
              date: {
                value: '',
                label: 'Date'
              },
              month: {
                value: '',
                label: 'Month'
              },
              year: {
                value: String(parseInt(currentYear) - 18),
                label: String(parseInt(currentYear) - 18)
              },
              loanamount: customerdetails.loanamount || '',
              comments: customerdetails.comment || '',

              isMobileEdit: false
            }
          };
          updateSteps([...newSteps]);
        } else {
          const freshSteps = updatedSteps;
          freshSteps[0] = {
            ...freshSteps[0],
            initialValues: {
              Name: '',
              middleName: '',
              lastName: '',
              email: '',
              mobile: '',
              pincode: '',
              EnquiryStatus: '',
              ProductId: '',
              date: {
                value: '',
                label: 'Date'
              },
              month: {
                value: '',
                label: 'Month'
              },
              year: {
                value: String(parseInt(currentYear) - 18),
                label: String(parseInt(currentYear) - 18)
              },
              loanamount: '',
              comments: ''
            }
          };
          updateSteps([...freshSteps]);
        }
      } catch (e) {
        console.log(e);
      }
    };
    getcustomer();
  }, []);
  const handleSubmit = React.useCallback(values => {
    console.log('full values:', values);

    return {
      message: 'Thanks for submitting!'
    };
  }, []);
  useEffect(() => {
    const getUserData = async Steps => {
      try {
        const userDetails = await getBasicDetails();
        //console.log({ userddd: userDetails });
        if (userDetails) {
          setUserName(userDetails?.name?.firstName || '');
          updateSteps(
            Steps.map(step => {
              return step;
            })
          );
        }
      } catch (err) {
        console.log(err);
        //throw new Error(err.message);
      }
    };
    getUserData();
  }, [Steps]);
  return (
    <React.Fragment>
      <Helmet title={`Add Lead | ${siteTitle}`} />
      <FormikWizard
        steps={updatedSteps}
        onSubmit={handleSubmit}
        render={FormWrapper}
      />
    </React.Fragment>
  );
};
export default AddleadSteps;
